// DS8.1.3
// DS8.1.3M - M - variant: vertical - but designers use it for desktop too
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import ModalWrapper from '../../ModalWrapper';
import ModalDoNotShowAgain from '../../ModalDoNotShowAgain';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';
const MessageModal = (_param)=>{
    var { variant , title , message , image , footerButtons , doNotShowAgainText , onDoNotShowAgainChange  } = _param, rest = _object_without_properties(_param, [
        "variant",
        "title",
        "message",
        "image",
        "footerButtons",
        "doNotShowAgainText",
        "onDoNotShowAgainChange"
    ]);
    return(// TODO: cleanup `as any` with the `modals_match_theme` feature
    /*#__PURE__*/ React.createElement(ModalWrapper, _extends({
        isFullscreen: false
    }, rest), variant === 'horizontal' ? /*#__PURE__*/ React.createElement(HorizontalLayout, {
        image: image,
        title: title,
        message: message,
        footerLeft: [
            onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
                key: "dns",
                doNotShowAgainText: doNotShowAgainText || '',
                onDoNotShowAgainChange: onDoNotShowAgainChange
            }), 
        ],
        footerRight: footerButtons
    }) : /*#__PURE__*/ React.createElement(VerticalLayout, {
        image: image,
        title: title,
        message: message,
        footerButtons: footerButtons,
        footerExtras: onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
            key: "dns",
            doNotShowAgainText: doNotShowAgainText || '',
            onDoNotShowAgainChange: onDoNotShowAgainChange
        })
    })));
};
MessageModal.displayName = 'MessageModal';
export default MessageModal;
